// The one big control: tap to talk, tap again when done. Its ring breathes
// with the microphone's level so the child can see it is hearing them.
import { Ear, Ellipsis, Hourglass, Mic, MicOff, Square } from "lucide-react";

export type TalkState =
  | "idle"
  | "listening"
  | "reading"
  | "thinking"
  /** The microphone belongs to a word's rung right now. */
  | "waiting"
  | "asleep";

const ICON = {
  idle: Mic,
  listening: Square,
  reading: Ear,
  thinking: Ellipsis,
  waiting: Hourglass,
  asleep: MicOff,
} as const;

const CAPTION: Readonly<Record<TalkState, string>> = {
  idle: "Tap, then tell me",
  listening: "I'm listening — tap when you're done",
  reading: "Listen…",
  thinking: "Writing it down…",
  waiting: "Let's finish that word first",
  asleep: "Ask a grown-up to turn on the microphone",
};

export function TalkButton({
  state,
  level,
  caption,
  onTap,
}: {
  state: TalkState;
  level: number;
  caption?: string;
  onTap: () => void;
}) {
  const Icon = ICON[state];
  return (
    <div className="flex flex-col items-center gap-3">
      <button
        type="button"
        className="compose-talk"
        data-state={state}
        style={
          {
            "--level": state === "listening" ? level : 0,
          } as React.CSSProperties
        }
        aria-label={caption ?? CAPTION[state]}
        disabled={state === "thinking" || state === "waiting"}
        onClick={onTap}
      >
        <Icon className="size-14" strokeWidth={2.25} />
      </button>
      <p
        className="m-0 text-center text-lg leading-tight"
        style={{ color: "var(--ink-soft)" }}
      >
        {caption ?? CAPTION[state]}
      </p>
    </div>
  );
}
